<template>
  <div v-if="embedded && hasPowerTrainOptions" class="col-12 refine-search-filter-embedded">
    <RefineSearchMultiCheckboxButton
      v-if="driveTrainOptions && driveTrainOptions.length > 0"
      class="q-mb-sm"
      full-width-on-mobile
      label="Drive train"
      :options="driveTrainOptions"
      v-model="localSelectedPowerTrain"
      :disabled="disabled || isFetchRatebookLoading"
    />
    <div style="height: 18px"></div>
    <RefineSearchMultiCheckboxButton
      v-if="tranmissionOptions && tranmissionOptions.length > 0"
      class="q-mb-sm"
      full-width-on-mobile
      label="Transmission"
      :options="tranmissionOptions"
      v-model="localSelectedTranmission"
      :disabled="disabled || isFetchRatebookLoading"
    />
  </div>
  <CustomExpansionItem v-else-if="!embedded && hasPowerTrainOptions" class="col-12 q-mb-sm" label="Power train" v-model="isOpen">
    <RefineSearchMultiCheckboxButton
      v-if="driveTrainOptions && driveTrainOptions.length > 0"
      class="q-mb-sm"
      full-width-on-mobile
      label="Drive train"
      :options="driveTrainOptions"
      v-model="localSelectedPowerTrain"
      :disabled="disabled || isFetchRatebookLoading"
    />
    <RefineSearchMultiCheckboxButton
      v-if="tranmissionOptions && tranmissionOptions.length > 0"
      class="q-mb-sm"
      full-width-on-mobile
      label="Transmission"
      :options="tranmissionOptions"
      v-model="localSelectedTranmission"
      :disabled="disabled || isFetchRatebookLoading"
    />
  </CustomExpansionItem>
</template>

<script>
import CustomExpansionItem from '../CustomExpansionItem';
import RefineSearchMultiCheckboxButton from './RefineSearchMultiCheckboxButton';

export default {
  name: 'PowerTrainFilterSection',
  props: {
    selectedPowerTrain: {
      type: Object,
      default: () => ({})
    },
    selectedTranmission: {
      type: Object,
      default: () => ({})
    },
    driveTrainOptions: {
      type: Array,
      required: true
    },
    tranmissionOptions: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isFetchRatebookLoading: {
      type: Boolean,
      default: false
    },
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      localSelectedPowerTrain: { ...this.selectedPowerTrain },
      localSelectedTranmission: { ...this.selectedTranmission },
      // Separate flags for each watcher pair to prevent interference
      isSyncingPowerTrain: false,
      isSyncingTranmission: false
    };
  },
  computed: {
    hasPowerTrainOptions() {
      return (
        (this.driveTrainOptions && this.driveTrainOptions.length > 0) || (this.tranmissionOptions && this.tranmissionOptions.length > 0)
      );
    }
  },
  watch: {
    selectedPowerTrain(newValue) {
      if (!this.isSyncingPowerTrain) {
        this.isSyncingPowerTrain = true;
        this.localSelectedPowerTrain = { ...newValue };
        this.$nextTick(() => {
          this.isSyncingPowerTrain = false;
        });
      }
    },
    selectedTranmission(newValue) {
      if (!this.isSyncingTranmission) {
        this.isSyncingTranmission = true;
        this.localSelectedTranmission = { ...newValue };
        this.$nextTick(() => {
          this.isSyncingTranmission = false;
        });
      }
    },
    localSelectedPowerTrain: {
      handler(newValue) {
        if (!this.isSyncingPowerTrain) {
          this.$emit('update:selectedPowerTrain', newValue);
          this.$emit('change');
        }
      },
      deep: true
    },
    localSelectedTranmission: {
      handler(newValue) {
        if (!this.isSyncingTranmission) {
          this.$emit('update:selectedTranmission', newValue);
          this.$emit('change');
        }
      },
      deep: true
    }
  },
  components: {
    CustomExpansionItem,
    RefineSearchMultiCheckboxButton
  }
};
</script>
